<template>
  <section>
    <div class="overflow-x-auto">
      <div class="inline-block min-w-full py-2 align-middle">
        <div class="overflow-hidden border-b border-ontick-steel-300 shadow dark:border-ontick-steel-600 sm:rounded-lg">
          <table class="min-w-full divide-y divide-ontick-steel-300 dark:divide-ontick-steel-600">
            <thead class="sticky top-0 bg-ontick-steel-100 dark:bg-ontick-steel-600">
              <tr>
                <th v-for="(item, index) in header" :key="index" scope="col" class="title_th">
                  {{ item }}
                </th>
              </tr>
            </thead>

            <tbody
              class="divide-y divide-ontick-steel-300 bg-gray-50 dark:divide-ontick-steel-600 dark:bg-ontick-graphite-500"
            >
              <tr v-for="item in data.orders" :key="item.order_id">
                <td class="td-items">
                  {{ item.symbol }}
                </td>
                <td class="td-items">
                  {{ item.order_id }}
                </td>
                <td class="td-items">
                  <span
                    :content="textTranslate(item.order_state)"
                    v-tippy="{ arrow: true, theme: 'green' }"
                    class="rounded px-3 py-1"
                    :class="badgerStatus(textStatus(item.order_state))"
                    >{{ textStatus(item.order_state) }}</span
                  >
                </td>
                <td class="td-items">
                  {{ item.order_time_setup | moment("DD/MM/YYYY HH:mm:ss:SSS") }}
                </td>
                <td class="td-items font-bold">
                  {{ item.order_goal }}
                </td>

                <td class="td-items">
                  <span class="px-2"> {{ item.type }}</span>
                </td>

                <td class="td-items">
                  <span
                    :content="item.type2"
                    v-tippy="{ arrow: true, theme: 'green' }"
                    class="rounded bg-ontick-prussian-400 px-3 py-1 text-ontick-prussian-50"
                  >
                    {{ textOrder(item.type2) }}</span
                  >
                </td>

                <td class="td-items">
                  {{ item.volume }}
                </td>
                <td class="td-items">
                  {{
                    item.price_entry | toCurrencyDecimalPlacesOrPoints(item.symbol_currency, item.symbol_decimal_places)
                  }}
                </td>
                <td class="td-items">
                  <span
                    class="font-semibold dark:font-medium"
                    :class="
                      item.profit == 0
                        ? 'text-ontick-steel-900 dark:text-gray-400'
                        : item.profit > 0
                          ? 'text-ontick-green-700 dark:text-ontick-green-500'
                          : 'text-ontick-red-600 dark:text-ontick-red-500'
                    "
                  >
                    {{ item.profit | toCurrencyDecimalPlacesOrPoints(item.account_currency, 2) }}
                  </span>
                </td>
                <td class="td-items flex cursor-pointer justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24px"
                    viewBox="0 0 24 24"
                    width="24px"
                    fill="currentColor"
                    @click="activeModal(item.order_id, data.investment_id)"
                    class="text-ontick-blue-500"
                  >
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
                    />
                  </svg>
                </td>
              </tr>
              <tr v-if="data.orders.length == 0" class="bg-gray-50 dark:bg-ontick-graphite-500">
                <td class="py-6" colspan="11">
                  <h2 class="text-center text-lg font-medium text-ontick-carbon-900 dark:text-gray-300">
                    Nenhuma ordem para exibir
                  </h2>
                </td>
              </tr>
              <tr v-if="data.orders.length > 0">
                <td colspan="11" align="center">
                  <button
                    v-if="order_msg != 'nenhuma ordem encontrada'"
                    @click="execNewOrder()"
                    class="mx-auto py-3 uppercase"
                  >
                    <div class="flex items-center">
                      <span class="text-ontick-blue-500" v-html="!submitted ? $icons.plus : $icons.loading"></span>

                      <p class="ml-3 font-semibold text-ontick-steel-900 dark:text-gray-300">Ver mais</p>
                    </div>
                  </button>
                  <div class="py-4 text-center" v-if="order_msg == 'nenhuma ordem encontrada'">
                    <h1 class="text-lg font-semibold text-ontick-carbon-900 dark:text-gray-300">
                      Sem dados para exibir
                    </h1>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <portal to="modal">
      <modalOrder
        v-if="active_modal"
        :active="active_modal"
        :params_id="params_id"
        @closeModal="active_modal = false"
      />
    </portal>
  </section>
</template>

<script>
import modalOrder from "@/app/modules/performance/components/performance/order/modal.component";
import placeholderTable from "@/app/shared/components/placeholder/placeholder-table.component";
import { mapActions, mapState } from "vuex";

export default {
  props: {
    data: {
      type: Object,
      default: null,
    },
  },

  components: {
    modalOrder,
    placeholderTable,
  },

  data() {
    return {
      date_order: {
        max: "",
        min: "",
      },
      submitted: false,
      active_modal: false,
      params_id: {},
      header: ["Ativo", "ID", "Status", "Data", "Sentido", "Tipo", "Ordem", "Volume", "Preço", "Resultado", "Detalhes"],
    };
  },

  computed: {
    ...mapState({
      order_msg: (state) => state.performance.order_msg,
    }),
  },
  methods: {
    ...mapActions({
      orderStrategies: "performance/orderStrategies",
    }),

    execNewOrder() {
      this.submitted = true;
      this.orderStrategies()
        .then(() => {
          this.submitted = false;
        })
        .catch(() => {
          this.submitted = false;
        });
    },

    textOrder(value) {
      let text = "";

      if (value == "Limite") {
        text = "L";
      } else if (value == "Stop Limite") {
        text = "S";
      }

      return text;
    },

    textTranslate(value) {
      switch (value) {
        case "CANCELED":
          return "Cancelada";
        case "FILLED":
          return "Executada";
        case "REJECTED":
          return "Rejeitada";
        case "PARTIAL":
          return "Parcial";
        case "EXPIRED":
          return "Expirada";
        case "FROZEN":
          return "Congelada";
        case "STARTED":
          return "Iniciada";
        case "PLACED":
          return "Colocada";
        default:
          return value;
      }
    },

    textStatus(value) {
      switch (value) {
        case "CANCELED":
          return "C";
        case "FILLED":
          return "F";
        case "REJECTED":
          return "R";
        case "PARTIAL":
          return "T";
        case "EXPIRED":
          return "E";
        case "FROZEN":
          return "Z";
        case "STARTED":
          return "S";
        case "PLACED":
          return "P";
        case "NEW":
          return "W";
        default:
          return value;
      }
    },

    badgerStatus(value) {
      let color = "";
      if (value == "P" || value == "PLACED") {
        color = "bg-ontick-blue-800 text-ontick-blue-200";
      } else if (value == "F") {
        color = "bg-ontick-lime-900 text-ontick-lime-400";
      } else if (value == "S") {
        color = "bg-ontick-teal-600 text-ontick text-ontick-teal-50";
      } else if (value == "W") {
        color = "bg-gray-600 text-gray-300";
      } else if (value == "C") {
        color = "bg-ontick-orange-900 text-ontick-orange-300";
      } else if (value == "R") {
        color = "bg-ontick-red-900 text-ontick-red-300";
      } else if (value == "E") {
        color = "bg-ontick-pink-900 text-ontick-link-300";
      } else if (value == "T") {
        color = "bg-ontick-yellow-800 text-ontick-yellow-50";
      }
      return color;
    },

    activeModal(order_id, investment_id) {
      this.active_modal = true;
      this.params_id = { order_id: order_id, investment_id: investment_id };
    },
  },
};
</script>

<style scoped>
.title_th {
  @apply px-3 py-2 text-center text-sm font-medium uppercase tracking-wider text-ontick-carbon-900 dark:text-gray-300;
}
.td-items {
  @apply whitespace-nowrap px-3 py-2 text-center text-xs text-ontick-carbon-900 dark:text-gray-300;
}
</style>
